import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React, { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddTeacherQuestionMutation } from "../../../Services/api";
export default function CreateTaskDetailsQuestion(props) {
    const notify = () => '';
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [addTeacherQuestion, isLoading] = useAddTeacherQuestionMutation();
    const onSubmit = (values, e) => {
        const formData = new FormData();
        formData.append('title', values.title);
        formData.append('descriptions', values.descriptions);
        formData.append('start_date', values.start_date);
        formData.append('end_date', values.end_date);
        formData.append('first_post_date', values.first_post_date);
        formData.append('course_task_id', props['id']);
        addTeacherQuestion(formData)
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    e.target.reset()
                    toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
        notify();
    };
    return (

        <div className="modal fade" id="fullscreenModalDetailsQuestion">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Question</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <section className="section">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Add Question</h5>
                                    <form onSubmit={handleSubmit(onSubmit)} >

                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                            <div className="col-sm-10">
                                                <input type="title" {...register("title", { required: true })} className="form-control" />
                                                {errors.title && <span className="text-danger">Title is required</span>}
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Start Date</label>
                                            <div className="col-sm-10">
                                                <input type="date" {...register("start_date", { required: true })} className="form-control" />
                                                {errors.start_date && <span className="text-danger">Start Date is required</span>}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">End Date</label>
                                            <div className="col-sm-10">
                                                <input type="date" {...register("end_date", { required: true })} className="form-control" />
                                                {errors.end_date && <span className="text-danger">End Date is required</span>}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">First Post Date</label>
                                            <div className="col-sm-10">
                                                <input type="date" {...register("first_post_date", { required: true })} className="form-control" />
                                                {errors.first_post_date && <span className="text-danger">First post date is required</span>}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Descriptions</label>
                                            <div className="col-sm-10">
                                                <textarea {...register("descriptions", { required: true })} className="form-control" rows={7}></textarea>
                                                {errors.descriptions && <span className="text-danger">Descriptions is required</span>}
                                            </div>
                                        </div>
                                        <div className="modal-footer">

                                            {isLoading.status !== 'pending' ?
                                                <>
                                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>                                                </>
                                                :
                                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                            }
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}